module.exports = __webpack_public_path__ + "img/zs_15@2x.093cb902.png";